/**
 * What this console knows, and what only a bench session can settle.
 *
 * Every line here comes from reading the firmware's own command reference
 * (branch 4.2.0, commit 3986962) against the way the console talks to it. They
 * are shown in the console rather than hidden in a document, because a
 * technician deserves to know which reading is certain and which is a reading
 * of the code.
 */
export const PROTOCOL_CAVEATS = [
  'A DIN response reports the module as its full wire code (52 for a relay module, 5a for a curtain module); the console reads the low nibble.',
  'Request dintype codes are 02 relay, 04 1–10 V, 06 phase cut, 08 fan, 0A curtain, 0C DALI bridge.',
  'DIN levels are 0–100 on the wire: 1–9 is raised to 10, anything above 100 is clamped, and 101/102 step down/up.',
  'A curtain module’s 0, 1 and 2 values are accepted but not documented; the console sends stop, open and close.',
  'The fan module’s speed semantics are not documented beyond the shared 0–100 scale.',
  'A DALI query answers with mode as a string (query, dim, temp), and a NAK as a number: 1 no response, 2 invalid address, 3 failed, 4 busy, 5 unsupported.',
  'A daliack never says which bridge it came from beyond master, so the console reads it as the answer to the request it just sent.',
  'getlogs asks for at most 128 lines, in batches of roughly 4 KiB every 250 ms; a line the RCU had to drop arrives as *** N lines dropped ***.',
  'coredump needs a stored image and a live MQTT session, and chunks can repeat: they are deduplicated by dump id, upload and sequence.',
  'OTA progress is reported at new multiples of ten and 100 is not guaranteed; the otaack is the only completion signal.',
  'A mapping read is limited by a 512-byte buffer on the device and the 511-byte publish slot, so a large scene set can come back truncated.',
  'listenpanel watches for a hard-coded five minutes, and a group-3 press that replaces a running scene produces no event at all.',
  'The MQTT command queue holds 20 messages and drops what it cannot publish within 100 ms, so commands are sent on demand only.',
  'The RCU also broadcasts acknowledgements to UDP 255.255.255.255:56000, which no browser can listen to: MQTT is the only readable channel.',
] as const;

/** The parts of the protocol that a bench session should confirm first. */
export const BENCH_CHECKS = [
  'Send a relay command and watch for rcuack on the events topic.',
  'Read one DIN module and confirm the module code in the reply is the full wire type.',
  'Drive a DALI address in dim mode and confirm the level matches the fixture.',
  'Press a scene button while watching the panel and confirm the group-3 coalescing behaviour.',
] as const;
